<template>
  <div class="test_menu clearfix">
    <a href="javascript:;" class="item">
      <em class="num">01</em>
      <h6 class="tit">心理健康问卷</h6>
      <p class="font">Mental health</p>
    </a>
  </div>
</template>
<script>
    export default{
        mounted(){
            this.fullscreen()
        }
    }
</script>


